module.exports = __webpack_public_path__ + "img/volume-slash-duo.eb7a9064.svg";